import { render } from "./Oops.vue?vue&type=template&id=ef1abef4&scoped=true"
import script from "./Oops.vue?vue&type=script&lang=js"
export * from "./Oops.vue?vue&type=script&lang=js"

import "./Oops.vue?vue&type=style&index=0&id=ef1abef4&lang=scss&scoped=true"

import exportComponent from "/home/pomelos/Projects/stowy-web-prod/stowy-web/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef1abef4"]])

export default __exports__